import axios from 'axios'
import { jwtDecode } from 'jwt-decode'
import React, { useEffect, useState } from 'react'

function Orders() {
  const [orders , setorders] = useState([])
  async function getAllOrders(id){
    const {data} = await axios.get('https://ecommerce.routemisr.com/api/v1/orders/user/' + id)
    console.log(data)
    setorders(data)
  }
  useEffect (()=>{
    const {id} = jwtDecode(localStorage.getItem('token'))
    getAllOrders(id)
  } , [])


  return (
    <>
  <div className="container">
  <h1>Your Orders</h1>
  {orders.map((order ) =>{
     return <div key ={order.id} className='row'>
      <div className="order shadow rouned p-4 my-5">
        <div className="d-flex align-items-center">
        <h2 className="fw-bolder h1">#{order.id}</h2>
        <h4 className="fw-bold text-primary mx-4" >Proccessing</h4>
        </div>
       

      <p>you have ordered{order.cartItems.length} items.</p>
      <div className="row d-flex">
        {order.cartItems.map((item)=>{
            return <img key={item.id} src={item.product.imageCover} style={{width:150}} alt=''/>
         } )}
      </div>
      <hr/>
      <p><strong>Total Amount :</strong>{order.totalOrderPrice}EGP</p>
     </div>
     </div>

  })
  }
  </div>
  </>
  )
}

export default Orders